import { Product } from "../../products/models/products.models";
import { ValidationMessage } from "../../_shared/models/shared.models";
import {
  isNullOrEmpty,
  hasSpecialChars,
  isInvalidEmail,
} from "../../_shared/shared.service";

export class StripeFormModel {
  Address?: string;
  City?: string;
  Email = "";
  Name = "";
  Phone = "";
  State = "";
  Zip = "";

  isValid(): ValidationMessage {
    const errorAry: string[] = [];
    const zipLength = 5;
    if (isNullOrEmpty(this.Address)) {
      errorAry.push("Address");
    } else if (hasSpecialChars(this.Address)) {
      return {
        HasError: true,
        Message: "No special characters in address.",
      };
    }

    if (isNullOrEmpty(this.Name)) {
      errorAry.push("Name");
    } else if (hasSpecialChars(this.Name)) {
      return {
        HasError: true,
        Message: "No special characters in name.",
      };
    } else if (this.Name.length > 100) {
      return {
        HasError: true,
        Message: "Name exceeds the character limit.",
      };
    }

    if (this.Zip === "" || this.Zip.length !== zipLength) {
      errorAry.push("Zip");
    }

    if (isNullOrEmpty(this.Email)) {
      errorAry.push("Email");
    } else if (isInvalidEmail(this.Email)) {
      return {
        HasError: true,
        Message: "Email is not correct format.",
      };
    } else if (this.Email.length > 100) {
      return {
        HasError: true,
        Message: "Email exceeds the character limit.",
      };
    }

    if (isNullOrEmpty(this.Phone)) {
      errorAry.push("Phone");
    }

    return {
      HasError: errorAry.length > 0,
      Message: `Missing or Invalid fields: ${errorAry.join(", ")}`,
    };
  }
}

export class PaymentRequest {
  Amount = 0;
  Description = "";
  ProductId = -1;
  Product: Product = null;
  Name?: string;
  Email?: string;
  Phone?: string;
  SName?: string;
  UserId?: number;
  OrderId?: number;
  OperatorId?: string;
  AccountId?: string;
  Date?: Date;
  SendReceipt?: boolean;
  ParticipantsUid?: string;
  SkipConfirmation?: boolean;
  EdjoinPaymentId?: string;
  EmailCcNotif?: boolean;
}
